export const MAX_SYNC_PASSES = 4;

function addResult(summary, result) {
  summary.pushed += Number(result.pushed || 0);
  summary.pulled += Number(result.pulled || 0);
  summary.conflicts += Number(result.conflicts || 0);
  summary.merged += Number(result.merged || 0);
  summary.rebased += Number(result.rebased || 0);
}

export async function drainSyncSession({
  runPass,
  shouldPause = () => false,
  maxPasses = MAX_SYNC_PASSES,
}) {
  const summary = {
    pushed: 0,
    pulled: 0,
    conflicts: 0,
    merged: 0,
    rebased: 0,
    pending: 0,
    passes: 0,
    settled: false,
    paused: false,
  };

  for (let pass = 0; pass < maxPasses; pass += 1) {
    const result = await runPass(pass);
    summary.passes += 1;
    summary.pending = Number(result.pending || 0);
    addResult(summary, result);

    if (!summary.pending) {
      summary.settled = true;
      return summary;
    }
    if (await shouldPause(result, pass)) {
      summary.paused = true;
      return summary;
    }
  }

  return summary;
}
